import styled from "styled-components"
import { List } from "@4cplatform/elements/Typography"

export const OrderedList = styled(List)`
  ol {
    font-size: 1.7rem;
  }
`
